module.exports = __webpack_public_path__ + "static/img/05.684484d2.png";